/** What one PM is headed, titled and sluglined with. */
interface PmText {
  heading: string
  assignmentTitle: string
  assignmentSlugline: string
}

export interface MemoValidityInput {
  hasTemplate: boolean
  requiresItems: boolean
  /** Picked items plus inserted PMs - an inserted PM is content in its own right. */
  contentCount: number
  unassignedCount: number
  /** An attached planning, or one a part-failed create filed PMs in. */
  hasPlanning: boolean
  planningTitle: string
  planningSlugline: string
  pms: PmText[]
  hasSection: boolean
  validRange: boolean
  requiresEditorialInfoType: boolean
  editorialInfoTypeCount: number
}

export type MemoValidity = Record<
  | 'template'
  | 'items'
  | 'unassigned'
  | 'planningTitle'
  | 'planningSlugline'
  | 'assignmentTitle'
  | 'assignmentSlugline'
  | 'heading'
  | 'section'
  | 'range'
  | 'editorialInfoType',
  boolean
>

/**
 * Every check a memo has to pass before it can be created, one per thing the
 * dialog can point at. Session and connection are not among them - those
 * disable the buttons instead.
 */
export function memoValidity(input: MemoValidityInput): MemoValidity {
  return {
    template: input.hasTemplate,
    items: !input.requiresItems || input.contentCount > 0,
    // An item still waiting on the batch bar's block choice is not yet part of the memo.
    unassigned: input.unassignedCount === 0,
    planningTitle: input.hasPlanning || !!input.planningTitle.trim(),
    planningSlugline: input.hasPlanning || !!input.planningSlugline.trim(),
    assignmentTitle: input.pms.every((pm) => !!pm.assignmentTitle.trim()),
    assignmentSlugline: input.pms.every((pm) => !!pm.assignmentSlugline.trim()),
    heading: input.pms.every((pm) => !!pm.heading.trim()),
    section: input.hasSection,
    range: input.validRange,
    editorialInfoType: !input.requiresEditorialInfoType || input.editorialInfoTypeCount > 0
  }
}

export function isMemoComplete(validity: MemoValidity): boolean {
  return Object.values(validity).every(Boolean)
}
